import { render, staticRenderFns } from "./OnlineExperimentGrade.vue?vue&type=template&id=f0c4d4c2&scoped=true&"
import script from "./OnlineExperimentGrade.vue?vue&type=script&lang=js&"
export * from "./OnlineExperimentGrade.vue?vue&type=script&lang=js&"
import style0 from "./OnlineExperimentGrade.vue?vue&type=style&index=0&id=f0c4d4c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c4d4c2",
  null
  
)

export default component.exports